module.exports = __webpack_public_path__ + "img/companyImg.b49a42ec.jpg";